import { useEffect } from "react";
import { usePatchPortfolioLifeInsuranceMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioLifeInsuranceMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getLifeInsuranceFormSchema } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";
import { mapPortfolioToLifeInsuranceForm } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/mapPortfolioToLifeInsuranceForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditLifeInsuranceFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditLifeInsuranceForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditLifeInsuranceFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioLifeInsuranceMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getLifeInsuranceFormSchema(t),
		defaultValues: mapPortfolioToLifeInsuranceForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
